import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'

import { LK_MUN_MEH_ROUTES as ROUTES } from './utils'
import { CreateElement } from 'vue'
import createFormRoutes from './Form/routes'
import createFormReviewRoutes from './Review/routes'
import createFormReviewSecondRoutes from './ReviewSecond/routes'
import createHostViewRoutes from './HostView/routes'
import { lkStoreModule } from '@/store/modules/lk'


type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'mun-meh',
    name: ROUTES.LAYOUT,
    redirect: { name: ROUTES.LIST },
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "mun-meh-lk.store" */
        './store'
      )
      registerModule(options)

      const storeModule = lkStoreModule.context(options.store)

      const promises = [
        storeModule.actions.getTopics().catch(() => ({})),
        storeModule.actions.getRoadmapsCount().catch(() => ({})),
        storeModule.actions.getMunMehCount().catch(() => ({})),
      ]

      await Promise.all(promises)

      next()
    },
    component: {
      name: 'LKMunMehLayout',
      render: (h: CreateElement) => h(
        'keep-alive',
        {
          props: {
            include: [
              'LKMunMehList',
              'LKMunMehView',
            ],
          },
        },
        [h('router-view')],
      ),
    },
    children: [
      ...createHostViewRoutes(options),
      ...createFormReviewSecondRoutes(options),
      ...createFormReviewRoutes(options),
      ...createFormRoutes(options),
      {
        path: ':id',
        name: ROUTES.VIEW,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "mun-meh-lk.view" */
          './LKMunMehView.vue'
        ),
      },
      {
        path: '/',
        name: ROUTES.LIST,
        component: (): PromiseVue => import(
          /* webpackChunkName: "mun-meh-lk.list" */
          './LKMunMehList.vue'
        ),
      },

    ],
  },
]

const createModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createModule
